import { Router, UrlTree } from '@angular/router';
import { Observable, catchError, map, of } from 'rxjs';
import { AuthService } from '../service/auth.service';

/**
 * Tenta il rinnovo dell'access token scaduto tramite il refresh token.
 * - successo: payload decodificato del nuovo token, pronto per i controlli di ruolo
 * - refresh token non valido (401): l'error.interceptor ha già mostrato il dialog
 *   e navigato al login, quindi qui si ritorna `false` senza aprirne un secondo
 * - altro errore (es. rete/timeout): nessun dialog mostrato finora, serve un
 *   redirect silenzioso al login
 */
export function refreshOrRedirect$(
  auth: AuthService,
  router: Router,
  returnUrl?: string,
): Observable<any | false | UrlTree> {
  return auth.refreshAccessToken().pipe(
    map((newToken) => JSON.parse(atob(newToken.split('.')[1]))),
    catchError((err) =>
      of(
        err?.status === 401
          ? false
          : router.createUrlTree(
              ['/login'],
              returnUrl ? { queryParams: { returnUrl } } : {},
            ),
      ),
    ),
  );
}
